import { click_origin_registration_wall } from '@news-mono/web-common'

/**
 * By the point this is invoked to be generated we dont need any location search params (utm tracking etc)
 * as they have already been consumed by the front end.
 */
export function generateRegwallLink(
    location: Location | URL,
    gaCookieId?: string,
) {
    const gaQueryParam = gaCookieId ? `&${gaCookieId.toLowerCase()}` : ''
    return `${location.origin}${location.pathname}?clickOrigin=${click_origin_registration_wall}${gaQueryParam}`
}
